import { render, staticRenderFns } from "./YcHeader.vue?vue&type=template&id=6f931bcc&scoped=true"
import script from "./YcHeader.vue?vue&type=script&lang=js"
export * from "./YcHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f931bcc",
  null
  
)

export default component.exports